export const OBJECTS_NAV_WIDTH_CSS_VAR = '--objects-nav-width';

export const OBJECTS_NAV_WIDTH_STORAGE_KEY = 'co4:objectsNavWidth';

/** Default width aligned with `$ob-drawer-width` in packages/app/_vars.scss */
export const OBJECTS_NAV_WIDTH_DEFAULT_PX = 236;
export const OBJECTS_NAV_WIDTH_MIN_PX = 180;
export const OBJECTS_NAV_WIDTH_MAX_PX = 560;

export function clampObjectsNavWidth(px: number): number {
  return Math.min(OBJECTS_NAV_WIDTH_MAX_PX, Math.max(OBJECTS_NAV_WIDTH_MIN_PX, Math.round(px)));
}
